<template>
  <div class="main">
    <div class="row m-2">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="pr-4">
          <button class="btn btn-info m-2" @click="refresh('refresh')">
            Refresh
          </button>

          <router-link class="btn btn-info m-2" :to="`/dashboard/add-route`">
            Add Route
          </router-link>
        </div>
      </div>

      <div class="spinner-grow" role="status" v-if="loading === true"></div>

      <div class="col-12">
        <card class="card-plain">
          <div class="table-full-width table-responsive">
            <table class="table">
              <thead class="thead-dark">
                <tr>
                  <th scope="col" class="text-center">S/N</th>
                  <th scope="col" class="text-center">Min Amount</th>
                  <th scope="col" class="text-center">Max Amount</th>
                  <th scope="col" class="text-center">Min Bin Range</th>
                  <th scope="col" class="text-center">Max Bin Range</th>
                  <th scope="col" class="text-center">Card Type</th>
                  <th scope="col" class="text-center">Processor</th>
                  <th scope="col" class="text-center">Alternate Processor</th>
                  <th scope="col" class="text-center">Agent Category</th>
                  <th scope="col" class="text-center">Institution Name</th>
                  <th scope="col" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(route, index) in routes" :key="route._id">
                  <th class="text-center">
                    {{ index + 1 }}
                  </th>
                  <td class="text-center">
                    {{ format.format(route.minAmount) }}
                  </td>
                  <td class="text-center">
                    {{ format.format(route.maxAmount) }}
                  </td>
                  <td class="text-center">{{ route.minRange }}</td>
                  <td class="text-center">{{ route.maxRange }}</td>
                  <td class="text-center">
                    {{ route.cardType ? getCardType(route.cardType) : "N/A" }}
                  </td>
                  <td class="text-center">
                    {{ route.processor }}
                  </td>
                  <td class="text-center">
                    {{ route.alternateProcessor }}
                  </td>
                  <td class="text-center">
                    {{
                      route.merchantId ? route.merchantId.merchantName : "N/A"
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      route.institutionId
                        ? route.institutionId.institutionName
                        : "N/A"
                    }}
                  </td>
                  <td
                    class="text-center"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <drop-down
                      class="nav-item"
                      title="Options"
                      id="list"
                      :is-open="route.isDropdownOpen"
                      @change="toggleDropdown(route._id)"
                    >
                      <div class="p-2">
                        <router-link :to="`/dashboard/routing/${route._id}`">
                          View route
                        </router-link>
                      </div>
                    </drop-down>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../store/axios";
import { mapActions } from "vuex";
import DropDown from "../components/multiDropDown.vue";

export default {
  components: { DropDown },

  data() {
    return {
      error: false,
      errorMsg: "",
      loading: false,
      routes: [],
      format: new Intl.NumberFormat("en-US"),
      autoRoute: {
        status: "inactive",
      },
    };
  },
  methods: {
    ...mapActions(["setNotification"]),
    toggleDropdown(id) {
      this.routes = this.routes.map((route) => {
        if (route._id === id) {
          route.isDropdownOpen = !route.isDropdownOpen;
        } else {
          route.isDropdownOpen = false;
        }
        return route;
      });
    },
    async refresh() {
      this.loading = true;
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/routings`);
        const { routes } = res.data;
        this.routes = routes;
        this.routes = routes.map((route) => ({
          ...route,
          isDropdownOpen: false,
        }));
      } catch (error) {
        if (error.response && error.response.data) {
          const { message } = error.response.data;
          this.setNotification({ type: "danger", message });
        } else {
          this.setNotification({
            type: "danger",
            message: "Unable to Fetch Routes",
          });
        }
      }
      this.loading = false;
    },
    getCardType(aid) {
      switch (aid) {
        case "A000000003":
          return "VISA";
        case "A000000004":
          return "Master Card";
        case "A000000371":
          return "VERVE";
        case "A000000065":
          return "JCB";
        case "A000000025":
          return "AMEX";
        case "A000000333":
          return "CUP";
        case "A000000152":
          return "Dinners";
      }
    },
  },
  async mounted() {
    // this.refresh();
    this.loading = true;
    try {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/routings`);
      const { routes } = res.data;
      this.routes = routes;
      this.routes = routes.map((route) => ({
        ...route,
        isDropdownOpen: false,
      }));
    } catch (error) {
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        this.setNotification({ type: "danger", message });
      } else {
        this.setNotification({
          type: "danger",
          message: "Unable to Fetch Routes",
        });
      }
    }
    this.loading = false;
  },
};
</script>
<style scoped>
.transaction {
  font-size: 12px;
}

th {
  font-size: 12px !important;
}

.spinner-grow {
  position: fixed;
}

#list {
  list-style-type: none;
}

tbody {
  background: #fff !important;
}

.list {
  list-style-type: none;
}
</style>
